<div *ngIf="devices.length > 0">
  <h3>Feuerstätten / Verbraucher</h3>
  <section *ngFor="let device of devices; first as isFirst; last as isLast">
    <div>
      <app-value-with-label
        *ngIf="device.deviceType"
        [label]="'Geräteart:'"
        [value]="device.deviceType | deviceGasTypePipe"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="device.manufacturer"
        [label]="'Hersteller, Typ:'"
        [value]="device.manufacturer"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="device.state"
        [label]="'Zustand:'"
        [value]="device.state"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="device.load"
        [label]="'Nennbelastung in kW:'"
        [value]="device.load.toString()"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="device.power"
        [label]="'Nennleistung in kW:'"
        [value]="device.power.toString()"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="device.location"
        [label]="'Aufstellort des Gerätes:'"
        [value]="device.location"></app-value-with-label>
    </div>
  </section>
  <div>
    <app-value-with-label
      *ngIf="totalPower"
      [label]="'Gesamt Leistung:'"
      [value]="(totalPower | number : undefined : 'de-DE') + ' kW'"></app-value-with-label>
  </div>
</div>
